import { Stack, Typography, Box } from "@mui/material";
import { FC } from "react";
import { background, text } from "@/theme/colors";
import { typography } from "@/theme/typography";
import { spacing } from "@/theme/variables";
import { VocabularyFilterType } from "@/infrastructure/adapters/vocabulary";

type TFilterOption = {
  value: VocabularyFilterType;
  label: string;
};

type TVocabularyFilterTabsProps = {
  value: VocabularyFilterType;
  onChange: (value: VocabularyFilterType) => void;
  options: TFilterOption[];
};

/** Pill-shaped filter tabs matching design spec */
export const VocabularyFilterTabs: FC<TVocabularyFilterTabsProps> = ({ value, onChange, options }) => {
  return (
    <Stack
      direction="row"
      sx={{
        height: 45,
        p: spacing.xxs,
        bgcolor: background.disable,
        borderRadius: "999px",
        gap: spacing.xxs,
      }}
    >
      {options.map((option) => {
        const isSelected = value === option.value;
        return (
          <Box
            key={option.value}
            onClick={() => onChange(option.value)}
            sx={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "999px",
              bgcolor: isSelected ? background.white : "transparent",
              cursor: "pointer",
              transition: "background-color 0.2s",
              userSelect: "none",
            }}
          >
            <Typography
              sx={{
                ...typography.body14Semi,
                color: isSelected ? text.primary : text.secondary,
                textAlign: "center",
              }}
            >
              {option.label}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};
